<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-message-tab *ngIf="selectedTab?.subTypeDetail?.data?.message" [message]="selectedTab?.subTypeDetail?.data.message" (clearMessage)="clearErrorMessage($event)"></lms-message-tab>
<div class="page-content" *ngIf="selectedTab && 'edit'===selectedTab.mode">
    <form [formGroup]="locoEditForm" (ngSubmit)="saveEditableLocoData(locoEditForm)">
        <lms-loco-top-actions [locoEditForm]='locoEditForm' [subTypes]='subTypes' [tab]='selectedTab' [locoSVG]='loadData' (editTab)='editLocomotiveDetails($event)'></lms-loco-top-actions>
        <div class="clear"></div>
        <div *ngIf="selectedTab?.subTypeDetail?.data?.status  == 'blank'" class="page-helper-text">
            <span>{{locoLabel.searchLoco}}</span>
        </div>
        <div *ngIf="selectedTab?.subTypeDetail?.data?.status  == 'error'" class="page-helper-text color-red">
            <span>{{locoLabel.locoException}}</span>
        </div>
        <div class="page-wrapper loco-data-scrollable-area" *ngIf="loadData && selectedTab?.subTypeDetail?.data?.status  == 'loaded'" formArrayName="editLoco" [style.height.px]='locoDataHeight'>
            <lms-loco-problems [listOfIncident]='loadData.listOfIncident' [locoLabel]='locoLabel'></lms-loco-problems>
            <div class="box-wrapper">
                <div class="note-list">
                    <h1>{{locoLabel?.notes}}</h1>
                    <ul *ngFor="let note of sortedNotesList(loadData.listOfNote); let i = index">
                        <lms-loco-data-notes [group]="locoEditForm.controls.editLoco.controls[i+3]" [note]='note' [id]='i' [tab]='selectedTab' [shownList]='loadData.shownList'></lms-loco-data-notes>
                    </ul>
                    <a href="javascript:void(0)" *ngIf='loadData.shownList > 3' (click)='showLessList();' class="show-less-data">
    					Show Less&nbsp;({{loadData.listOfNote.length - 3}})
  					</a>
                    <a href="javascript:void(0)" *ngIf='loadData.shownList === 3 && loadData.listOfNote.length > 3' (click)='showMoreList();' class="show-more-data">
   						 Show More&nbsp;({{loadData.listOfNote.length - 3}})
  					</a>
                </div>
            </div>
            <div class="loco-page-responsive">
                <div class="row">
                    <lms-loco-inspection [locoData]='loadData' [locoLabel]='locoLabel' [group]="locoEditForm.controls.editLoco.controls[2]" [tab]='selectedTab' [errorMap]='errorMap'></lms-loco-inspection>
                </div>
                <div class="box-wrapper">
                    <div class="row">
                        <div class="col-sm-3 pdr5">
                            <lms-loco-assignment [locoData]='loadData' [locoLabel]='locoLabel'></lms-loco-assignment>
                            <lms-loco-information [locoData]='loadData' [group]="locoEditForm.controls.editLoco.controls[0]" [locoLabel]='locoLabel' [tab]='selectedTab' [errorMap]='errorMap'></lms-loco-information>
                        </div>
                        <div class="col-sm-3 pdr5 pdl5">
                            <lms-loco-last-reported [locoData]='loadData' [locoLabel]='locoLabel'></lms-loco-last-reported>
                        </div>
                        <div class="col-sm-3 pdr5 pdl5">
                            <lms-loco-trip-plan-list [listOfTripPlan]='loadData.listOfTripPlan' [locoLabel]='locoLabel'></lms-loco-trip-plan-list>
                        </div>
                        <div class="col-sm-3 pdl5">
                            <lms-loco-fuel [locoData]='loadData' [group]="locoEditForm.controls.editLoco.controls[1]" [locoLabel]='locoLabel' [tab]='selectedTab' [errorMap]='errorMap'></lms-loco-fuel>
                        </div>
                    </div>
                </div>

            </div>

            <div class="loco-page-features">
                <lms-loco-features [listOfFeature]='loadData.listOfFeature' [locoLabel]='locoLabel'></lms-loco-features>
            </div>
        </div>
    </form>
</div>
<div class="page-content" *ngIf="selectedTab && 'edit'!=selectedTab.mode">
    <lms-loco-top-actions [subTypes]='subTypes' [tab]='selectedTab' [locoSVG]='loadData' (editTab)='editLocomotiveDetails($event)' (locoAddInit)='addLocoInitiated($event)'></lms-loco-top-actions>
    <div class="clear"></div>
    <div *ngIf="selectedTab?.subTypeDetail?.data?.status  == 'blank'" class="page-helper-text">
        <span>{{locoLabel.searchLoco}}</span>
    </div>
    <div *ngIf="selectedTab?.subTypeDetail?.data?.status  == 'error'" class="page-helper-text color-red">
        <span>{{locoLabel.locoException}}</span>
    </div>
    <div class="page-wrapper loco-data-scrollable-area" *ngIf="loadData && selectedTab?.subTypeDetail?.data?.status  == 'loaded'" [style.height.px]='locoDataHeight'>
        <lms-loco-problems [listOfIncident]='loadData.listOfIncident' [locoLabel]='locoLabel'></lms-loco-problems>
        <div class="box-wrapper">
            <div class="note-list">
                <h1>{{locoLabel?.notes}}</h1>
                <ul *ngFor="let note of sortedNotesList(loadData.listOfNote); let i = index">
                    <lms-loco-data-notes [shownList]='loadData.shownList' [note]='note' [id]='i' [tab]='selectedTab'></lms-loco-data-notes>
                </ul>
                <a href="javascript:void(0)" *ngIf='loadData.shownList > 3' (click)='showLessList();' class="show-less-data">
    					Show Less&nbsp;({{loadData.listOfNote.length - 3}})
  					</a>
                <a href="javascript:void(0)" *ngIf='loadData.shownList === 3 && loadData.listOfNote.length > 3' (click)='showMoreList();' class="show-more-data">
   						 Show More&nbsp;({{loadData.listOfNote.length - 3}})
  					</a>
            </div>
        </div>
        <div class="loco-page-responsive">
            <div class="row">
                <lms-loco-inspection [locoData]='loadData' [locoLabel]='locoLabel' [tab]='selectedTab'></lms-loco-inspection>
            </div>
            <div class="box-wrapper">
                <div class="row">
                    <div class="col-sm-3 pdr5">
                        <lms-loco-assignment [locoData]='loadData' [locoLabel]='locoLabel'></lms-loco-assignment>
                        <lms-loco-information [locoData]='loadData' [locoLabel]='locoLabel' [tab]='selectedTab'></lms-loco-information>
                    </div>
                    <div class="col-sm-3 pdr5 pdl5">
                        <lms-loco-last-reported [locoData]='loadData' [locoLabel]='locoLabel'></lms-loco-last-reported>
                    </div>
                    <div class="col-sm-3 pdr5 pdl5">
                        <lms-loco-trip-plan-list [listOfTripPlan]='loadData.listOfTripPlan' [locoLabel]='locoLabel'></lms-loco-trip-plan-list>
                    </div>
                    <div class="col-sm-3 pdl5">
                        <lms-loco-fuel [locoData]='loadData' [locoLabel]='locoLabel' [tab]='selectedTab'></lms-loco-fuel>
                    </div>
                </div>
            </div>

        </div>

        <div class="loco-page-features">
            <lms-loco-features [listOfFeature]='loadData.listOfFeature' [locoLabel]='locoLabel'></lms-loco-features>
        </div>
    </div>
</div>